import { Component, Inject, TemplateRef, HostListener, EventEmitter, OnInit, HostBinding, OnDestroy } from '@angular/core';

import { ToastRef } from './toast-ref';
import { TOAST_CONFIG_DATA } from './toast.tokens';
import { AnimationEvent } from '@angular/animations';
import { toastAnimations, ToastAnimationState } from './toast-animations';
import { ToastContent, ToastConfig } from './toast.service';

@Component({
  selector: 'suka-toast',
  template: `
    <div class="toast"
      [@fadeAnimation]="{
        value: animationState,
        params: {
          fadeIn: toastConfig.animation.fadeIn,
          fadeOut: toastConfig.animation.fadeOut
        }
      }"
      (@fadeAnimation.done)="onFadeFinished($event)"
      [ngClass]="{
        'toast--success': content.type === 'success',
        'toast--alert': content.type === 'alert',
        'toast--attention': content.type === 'attention'
      }"
    >
      <suka-icon icon="check" *ngIf="content.type === 'success'" class="toast__icon--success"></suka-icon>
      <suka-icon icon="alert-circle" *ngIf="content.type === 'alert'" class="toast__icon--alert"></suka-icon>
      <suka-icon icon="alert-triangle" *ngIf="content.type === 'attention'" class="toast__icon--attention"></suka-icon>
      <div>{{ content.body }}</div>
      <suka-icon icon="x" (click)="close()" class="toast__close">close</suka-icon>
    </div>
  `,
  animations: [toastAnimations.fadeToast],
})
export class ToastContainer implements OnInit, OnDestroy {
  private intervalId: number;

  public animationState: ToastAnimationState = 'default';
  public animationStateChanged = new EventEmitter<AnimationEvent>();
  showFooter = false;
  primaryActions: [];
  secondaryActions: [];
  content: ToastContent;

  @HostBinding('class.toast--default') baseClass = true;

  constructor(
    public toastRef: ToastRef,
    @Inject(TOAST_CONFIG_DATA) public toastConfig: any
  ) { }

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }

  ngOnInit() {
    this.content = this.toastConfig.content;
    this.intervalId = window.setTimeout(() => this.startExitAnimation(), 5000);
  }

  ngOnDestroy() {
    clearTimeout(this.intervalId);
  }

  close() {
    this.toastRef.close();
  }

  onAnimationStart(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  onAnimationDone(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  closeToast($event: any) {
    this.toastRef.close();
  }

  onFadeFinished(event: AnimationEvent) {
    const { toState } = event;
    const isFadeOut = (toState as ToastAnimationState) === 'closing';
    const itFinished = this.animationState === 'closing';

    if (isFadeOut && itFinished) {
      this.close();
    }
  }

  startExitAnimation() {
    this.animationState = 'closing';
  }
}
